// The one line a screen shows when the server refused something.
//
// Promise:
// - The server's own message wins (it can say the most, e.g. why a role cannot
//   do this), unless it is not meant for people (code "unknown" / "internal").
// - A 403 without a message says plainly that permission is missing; it beats
//   the caller's fallback, since the cause is known.
// - Otherwise the caller's fallback.
import { m } from "@trameria/i18n";
import { ApiError } from "./api";

const UNREADABLE_CODES: ReadonlySet<string> = new Set(["unknown", "internal"]);

export function isForbidden(error: unknown): boolean {
  return error instanceof ApiError && error.status === 403;
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    if (error.message && !UNREADABLE_CODES.has(error.code))
      return error.message;
    if (error.status === 403) return m.common_forbidden();
  }
  return fallback;
}

/**
 * The same line with what was being done in front ("Could not stop main"),
 * for rows where the server's message does not name the target.
 */
export function apiErrorWithLead(error: unknown, lead: string): string {
  const message = apiErrorMessage(error, "");
  return message === "" ? lead : m.common_error_with_lead({ lead, message });
}
